import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-a-text-input');

window.KFTextInput = window.KFTextInput || {
  elements: document.querySelectorAll(getClass(undefined, { checkAttached: true })),
  init() {
    this.elements = document.querySelectorAll(getClass(undefined, { checkAttached: true }));

    [].forEach.call(this.elements, (el: HTMLElement) => {
      this.setUpTextInput(el);
    });
  },
  setUpTextInput(el: HTMLElement) {
    if (!el) return;
    el.dataset.eventAttached = 'true';

    const input = el.querySelector<HTMLInputElement>(getClass('input'));

    if (!input) return;

    if (input.dataset.isCurrency) {
      input.inputMode = 'numeric';
      input.addEventListener('keypress', (e) => {
        const charCode = e.key;
        const numberCharRegex = /[0-9]/;

        if (!numberCharRegex.test(charCode)) return e.preventDefault();

        if (input.value.replace(/,/g, '').length >= 12) return e.preventDefault();
      });

      input.addEventListener('keyup', () => {
        let value: number | string = parseInt(input.value.replace(/,/g, ''));

        if (!value) {
          input.value = '';

          return;
        } else {
          value = value.toString();
        }

        // Store selection start before formatting
        let selectionStart = input.selectionStart ?? input.value.length;
        const prevLength = input.value.length;

        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        input.value = value;

        // Calculate new selection start after commas are added
        const newLength = input.value.length;
        const diff = newLength - prevLength;

        selectionStart += diff;

        // Restore selection start if possible
        input.setSelectionRange(selectionStart, selectionStart);
      });
    }
  },
};

window.KFTextInput.init();
export {};
